import React from 'react';
import styled from 'styled-components';
import { logError } from '../../utils/error-handler';
import './error-boundary.css';

const ErrorContainer = styled.div`
  background-color: ${({ theme }) => theme?.bg || '#1C1C27'};
  color: ${({ theme }) => theme?.text_primary || '#F2F3F4'};
`;

const ErrorTitle = styled.h2`
  color: ${({ theme }) => theme?.text_primary || '#F2F3F4'};
`;

const ErrorMessage = styled.p`
  color: ${({ theme }) => theme?.text_secondary || '#b1b2b3'};
`;

const RetryButton = styled.button`
  background: linear-gradient(
    225deg,
    hsla(271, 100%, 50%, 1) 0%,
    hsla(294, 100%, 50%, 1) 100%
  );
  color: white;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(5, 150, 105, 0.4);
  }
`;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    logError(error, 'ErrorBoundary', {
      componentStack: errorInfo.componentStack,
    });

    this.setState({
      error,
      errorInfo,
    });
  }

  handleRetry = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null,
    });
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorContainer className="error-container">
          <ErrorTitle className="error-title">
            Oops! Something went wrong
          </ErrorTitle>
          <ErrorMessage className="error-message">
            We're sorry, but something unexpected happened. Please try
            refreshing the page or contact support if the problem persists.
          </ErrorMessage>
          <RetryButton onClick={this.handleRetry} className="retry-button">
            Try Again
          </RetryButton>
        </ErrorContainer>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
